
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookie-declaration",
      function () {
        return require("private-next-pages/cookie-declaration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookie-declaration"])
      });
    }
  